export function isBronPast(model) {
  if (model.broneeringu_algus && model?.broneeringu_lopp) {
    let endTime = model?.broneeringu_lopp;
    endTime = endTime.split(".");
    endTime = endTime[1] + "-" + endTime[0] + "-" + endTime[2];
    let theEnd = new Date(Date.parse(endTime.replace(/-/g, "/")));
    let dateNow = new Date(Date.now());
    dateNow.setDate(dateNow.getDate() - 1);
    let isPast = dateNow.getTime() - theEnd.getTime();
    return isPast < 0 ? 1 : 0;
  }
}


export function isBronActive(model) {
if (model.broneeringu_algus && model?.broneeringu_lopp) {
    let endTime = model?.broneeringu_lopp;
    endTime = endTime.split(".");
    endTime = endTime[1] + "-" + endTime[0] + "-" + endTime[2];
    let theEnd = new Date(Date.parse(endTime.replace(/-/g, "/")));
    
    let startTime = model.broneeringu_algus;
    startTime = startTime.split(".");
    startTime = startTime[1] + "-" + startTime[0] + "-" + startTime[2];
    let start = new Date(Date.parse(startTime.replace(/-/g, "/")));
    
    
    let dateNow = new Date(Date.now());
    dateNow.setDate(dateNow.getDate() - 1);
    let isPast = dateNow.getTime() - theEnd.getTime();
    if(dateNow < theEnd.getTime() && dateNow > start.getTime()){
      return true;
    }else{
      return false;
    }
 
  }
}
